import {
  NotificationLevel,
  type ExtraOptions,
  type INotification,
  type NotificationMessage,
} from '../types';
import { notificationStore } from '../notification-store';
import { INotificationApi } from './api.types';

export class NotificationApi implements INotificationApi {
  dismiss(id: string) {
    notificationStore.dismiss(id);
  }

  showWarning(message: NotificationMessage, extraOptions?: ExtraOptions) {
    return notificationStore.setFloatingBannerNotification(message, NotificationLevel.Warning, extraOptions);
  }

  showInfo(message: NotificationMessage, extraOptions?: ExtraOptions) {
    return notificationStore.setFloatingBannerNotification(message, NotificationLevel.Info, extraOptions);
  }

  add(notification: INotification) {
    return notificationStore.add(notification);
  }

  removeAllTopBanners() {
    return notificationStore.removeAllTopBanners();
  }
}

export const notificationApi = new NotificationApi();

// Put it here only for debugging purpose
const notificationApiDebugWindow = window as Window & { notificationApi?: NotificationApi };
notificationApiDebugWindow.notificationApi = notificationApi;
